import { LegalLayout } from "@/components/LegalLayout";
import { Ph } from "@/lib/draft";

export default function PrivacyPage() {
    return (
        <LegalLayout title="Privacy policy">
            <p>
                <strong>Bozza predisposta per la pubblicazione:</strong> i campi del titolare vanno completati prima
                di andare online.
            </p>
            <h2>1. Titolare del trattamento</h2>
            <p>
                River Pub di Giuntini Andrea F. &amp; C. sas — Via Covona 160, 51039 Quarrata (PT). Partita IVA /
                Codice Fiscale: 00362290470. Contatto email ufficiale (PEC): riverpub@pec.it — il locale non
                dispone di un indirizzo email ordinario pubblico.
            </p>
            <h2>2. Dati trattati</h2>
            <p>Il sito non contiene form di raccolta dati e non effettua profilazione. Vengono trattati solo:</p>
            <ul>
                <li>dati di navigazione forniti dal browser (es. log del server), conservati per tempi ordinari;</li>
                <li>
                    preferenze salvate sul tuo dispositivo tramite localStorage (esito del consenso ai cookie), che
                    restano nel tuo browser e non vengono inviati al titolare.
                </li>
            </ul>
            <h2>3. Servizi di terze parti</h2>
            <ul>
                <li>
                    <strong>Google Maps</strong>: la mappa nella sezione «Dove siamo» è un servizio di Google;
                    viene caricata solo dopo il tuo consenso esplicito. Al caricamento, Google può acquisire dati di
                    navigazione secondo le proprie informative.
                </li>
                <li>
                    <strong>Google Fonts</strong>: i caratteri tipografici sono serviti dai server di Google, che
                    possono registrare l'indirizzo IP.
                </li>
            </ul>
            <h2>4. I tuoi diritti</h2>
            <p>
                Secondo il Regolamento UE 2016/679 (GDPR) puoi chiedere accesso, rettifica o cancellazione dei tuoi
                dati scrivendo alla PEC del titolare: riverpub@pec.it.
            </p>
            <h2>5. Aggiornamenti</h2>
            <p>
                Questa informativa può essere aggiornata; le modifiche saranno pubblicate su questa pagina. Ultimo
                aggiornamento: <Ph what="data ultimo aggiornamento" />.
            </p>
        </LegalLayout>
    );
}